@if (!dot()) {
  <ng-content />
}
